import React from "react";
import ReturnButton from "./ReturnButton";

const CHROME_WEBSTORE_URL =
  "https://chromewebstore.google.com/detail/vrepop/depkoiepmnjkkbpcimmfhfndjjbbpkbl";

export default function InstallPC() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50">
      <ReturnButton />

      <div className="bg-white p-8 rounded-xl shadow-lg max-w-2xl w-full">
        <h1 className="text-3xl font-bold mb-4 text-blue-600 text-center">
          Installer V-repop sur PC
        </h1>

        <p className="text-center text-gray-600 mb-8">
          Découvrez comment utiliser V-repop en quelques étapes simples.
        </p>

        <ol className="list-decimal list-inside space-y-4 text-gray-700 text-base">
          <li>
            Installez l’extension Chrome en cliquant{" "}
            <a
              href={CHROME_WEBSTORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline font-medium"
            >
              ici
            </a>{" "}
            (recherchez <b>Vrepop</b> dans le Chrome Web Store).
          </li>

          <li>
            Connectez-vous à votre compte Vinted puis ouvrez la page qui affiche
            toutes vos annonces.
          </li>

          <li>
            Le widget <b>V-repop</b> apparaît automatiquement en bas à gauche.
          </li>

          <li>
            Connectez-vous à votre compte V-repop (ou créez-en un) et vérifiez
            que votre abonnement est actif.
          </li>

          <li>
            Choisissez les modifications à appliquer lors de la republication
            (titre, prix, catégories, photos, rotation, cadres…).
          </li>

          <li>
            Après validation des modifications, le bouton{" "}
            <b>“Republier”</b> apparaît directement sur la grille de vos annonces :
            vous pouvez commencer.
          </li>
        </ol>

        <div className="mt-8 text-center">
          <a
            href={CHROME_WEBSTORE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition"
          >
            Télécharger V-repop
          </a>
        </div>
      </div>
    </div>
  );
}